import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import './App.css';

const INACTIVITY_MS = 60 * 60 * 1000;
const CHECK_INTERVAL_MS = 60 * 1000;

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function RootRedirect() {
  const token = localStorage.getItem('token');
  return <Navigate to={token ? '/dashboard' : '/login'} replace />;
}

function CatchAllRedirect() {
  const token = localStorage.getItem('token');
  return <Navigate to={token ? '/dashboard' : '/login'} replace />;
}

function InactivityGuard({ children }) {
  const lastActivity = useRef(Date.now());
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const updateActivity = () => {
      lastActivity.current = Date.now();
    };

    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach((ev) => window.addEventListener(ev, updateActivity));

    const intervalId = setInterval(() => {
      if (!localStorage.getItem('token')) {
        clearInterval(intervalId);
        return;
      }
      if (Date.now() - lastActivity.current >= INACTIVITY_MS) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }, CHECK_INTERVAL_MS);

    return () => {
      events.forEach((ev) => window.removeEventListener(ev, updateActivity));
      clearInterval(intervalId);
    };
  }, [location.pathname]);

  return children;
}

function App() {
  return (
    <Router>
      <div className="App">
        <InactivityGuard>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/" element={<RootRedirect />} />
            <Route path="*" element={<CatchAllRedirect />} />
          </Routes>
        </InactivityGuard>
      </div>
    </Router>
  );
}

export default App;
